import { v4 as uuid } from 'uuid';
import { encounterIdC } from '../encounters';
import { Order, OrderType } from '@getvim-os/types';

export const orderC: Order = {
  id: uuid(),
  type: OrderType.PROCEDURE,
  icd: [{ name: 'Transsexualism', code: 'F64.0' }],
  cpts: [
    {
      name: 'Adjacent tissue transfer or rearrangement, trunk; defect 10 sq cm or less',
      code: '14000',
    },
  ],
  encounterId: encounterIdC,
  createdDate: '2000-01-01',
};
